import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ButtonComponent from "../button";
// import Button from "@mui/material/Button";

const BackButton = () => {
    return (
        // <Button variant="contained" size="small" startIcon={<ChevronLeftIcon />} className="back-button" onClick={() => window.history.back()}>
        //     Go Back
        // </Button>
        <ButtonComponent
            icon={ChevronLeftIcon}
            label="Go Back"
            onClick={() => window.history.back()}
            size="small"
            upperCase
            className="back-button"
        />
    );
};

export default BackButton;